export default 'locale'
